import { z } from "zod";

export const presignedUrlDto = z.object({
  fileName: z.string().min(1),
});

export type PresignedUrlReq = z.infer<typeof presignedUrlDto>;

/** Proxy download of a placement document / originalSpecs URL. */
export const downloadByUrlDto = z.object({
  url: z.string().url().max(4096),
  filename: z.string().max(512).optional(),
});

export type DownloadByUrlReq = z.infer<typeof downloadByUrlDto>;
